import React from 'react';
import ReactDOM from 'react-dom/client';

// Importa o componente principal que controla toda a aplicação
import App from './App';

// Importa os estilos globais para que toda a aplicação os utilize
import './assets/styles/global.css';

// Encontra a div com id="root" no arquivo public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Diz ao React para renderizar nosso componente <App> dentro daquela div
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);